import { render } from "./id-pal-verify.vue?vue&type=template&id=01336492&scoped=true"
import script from "./id-pal-verify.vue?vue&type=script&lang=js"
export * from "./id-pal-verify.vue?vue&type=script&lang=js"

import "./id-pal-verify.vue?vue&type=style&index=0&id=01336492&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01336492"]])

export default __exports__